



















































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IColorDetail, IColorRecord } from './types';
import ColorWheelUnit from './ColorUnit.vue';

// 10个细分颜色
@Component({
  components: { ColorWheelUnit },
})
export default class ColorWheelSub extends Vue {
  @Prop() public parent!: IColorDetail | null;  // 父颜色
  @Prop() public width!: string | number;       // 颜色块的高度, 仅当垂直布局生效
  @Prop() public height!: string | number;      // 颜色块的高度, 仅当水平布局生效
  @Prop({ type: Boolean, default: false }) public vertical!: boolean;   // 是否垂直布局
  @Prop({ type: Boolean, default: false }) public selectable!: boolean; // 是否允许选择颜色块

  public selected: IColorRecord | null = null; // 选中的数据

  // 垂直布局时容器样式
  public get verticalWrapStyle() {
    return { width: '120px', height: '100%' };
  }

  // 颜色块的高度(仅当水平布局生效)
  public get unitHeight() {
    const h = parseInt(`${this.height}`, 10) || 24;
    return { height: h, mHeight: h * 3 + 16 };
  }

  public get items() {
    return this.parent?.color_list || [];
  }

  // 最后一个颜色(大颜色块)
  public get mainColors() {
    return this.items.slice(-1);
  }

  // 前9个颜色(重排顺序, 每3个颜色顺序翻转)
  public get minorColors() {
    const list = this.items.slice(0, -1);
    const sortIndexes = [2, 1, 0, 5, 4, 3, 8, 7, 6];
    return sortIndexes.map((sortNo) => list[sortNo]);
  }

  // 父颜色是否是暗色
  public get isDarkHue() {
    const hue = this.parent?.color?.hue || -1;
    return hue > 18 && hue < 27;
  }

  // 是否是暗色
  public isDark(record: IColorRecord) {
    const darkSbValues = [1, 2, 4, 5, 7, 8];
    return this.isDarkHue || darkSbValues.indexOf(record.sb) > -1;
  }

  // 是否被选中
  public isSelect(record: IColorRecord) {
    const sVal = this.selected;
    const selectedVal = sVal ? `${sVal.hue}_${sVal.sb}` : '';
    return `${record.hue}_${record.sb}` === selectedVal;
  }

  // 取消选中
  @Emit('select')
  public unselect() {
    this.selected = null;
    return null;
  }

  // 颜色被选中或取消选中时
  @Emit('select')
  public onToggleSelect(record: IColorRecord) {
    this.selected = this.isSelect(record) ? null : { ...record };
    return this.selected;
  }

  // 父颜色变更时，清除选中
  @Watch('parent')
  public currentChange() {
    this.unselect();
  }
}
